import { post, get } from '../helpers/fetchServicesMethods';
import { toast } from 'react-toastify';
import { url } from '../reducers/url';
import PubSub from 'pubsub-js';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

export const convertXml = async (data, history, t) => {
    // dispatch(setUser({ GQUSERID: data.GQUSERID, isLoggedIn: true }));
    // const history = useHistory();
    var domParser = new DOMParser();

    var dom = domParser.parseFromString(data.st26input, 'text/xml');
    var x = dom.getElementsByTagName('parsererror').length ? (new XMLSerializer()).serializeToString(dom) : 'all good';
    if (dom.getElementsByTagName('parsererror').length > 0) {
        toast.error(dom.getElementsByTagName('parsererror')[0].getElementsByTagName('div')[0].innerHTML);
      }

    if (dom.getElementsByTagName('parsererror').length) {
        return 'parsererror';
    }
    else {
        var sd = dom.getElementsByTagName('SequenceData');
        var prt = '';
        var dna = '';
        var prtCount = 0;
        var dnaCount = 0;
        if (sd.length == 0) {
            return 'empty';
        }
        for (var i = 0; i < sd.length; i++) {
            var nNode = sd.item(i);
            if (nNode.nodeType == Node.ELEMENT_NODE) {
                var mol = nNode.getElementsByTagName('INSDSeq_moltype');
                var seqId = nNode.getAttribute('sequenceIDNumber');
                var seqTag = nNode.getElementsByTagName('INSDSeq_sequence');
                if (mol.length == 0 || seqId == null || seqTag.length == 0 || seqId.length == 0) {
                    return 'missing';
                }
                else {
                    var moltype = mol.item(0).textContent;
                    var seq = seqTag.item(0).textContent;
                    if (moltype == 'AA' || moltype == 'PRT') {
                        prt += '>SEQ_NO_' + seqId + '\n' + seq + '\n';
                        prtCount++;
                    }
                    if (moltype == 'DNA' || moltype == 'RNA') {
                        dna += '>SEQ_NO_' + seqId + '\n' + seq + '\n';
                        dnaCount++;
                    }
                }

            }
        }

        var x = [prt, dna, prtCount, dnaCount];
        return x;
    }

};

export const convertText = async (data, history, t) => {
    if(!data.st26input.startsWith(">")){
        return 'parsererror';
    }
    else if(data.st26input === ''){
        return 'empty'
    }
    else {
        const big = [];
        var lines = (data.st26input).split('\n');
        let ind = -1;
        for (var line = 0; line < lines.length; line++) {
            if (lines[line].startsWith(">")){
                let [first, ...rest] = lines[line].slice(1).split(' '); // Remove '>' character by slicing the line
                rest = rest.join(' ');
                const arr = [];
                arr.push(first, rest);
                big.push(arr);
                ind++;
            }
            else {
                big[ind].push(lines[line]);
            }
        }
        
        const small = [];
        for (var i = 0; i < big.length; i++){
            const l = big[i].slice(2).join("");
            const nee = big[i].slice(0, 2).concat(l);
            small[i] = nee;
        }      
        return small;
    }
};

export const convertFastaForParsedXml = async (data, history, t) => {
    if(!data.st26input.startsWith(">")){
        return 'parsererror';
    }
    else if(data.st26input === ''){
        return 'empty'
    }
    else {
        let prt = '';
        let dna = '';
        let prtCount = 0;
        let dnaCount = 0;
        
        const lines = data.st26input.split('\n');
        let currentSeq = '';
        let currentHeader = '';
        
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            
            if (line.startsWith('>')) {
                // Process previous sequence if exists
                if (currentSeq && currentHeader) {
                    // Extract number from original header and format as SEQ_NO_XXXX
                    const headerText = currentHeader.substring(1); // Remove '>'
                    const numberMatch = headerText.match(/-(\d+)/); // Look for pattern like -0032
                    let sequenceId;
                    if (numberMatch) {
                        // Found a number after dash, use it with SEQ_NO_ prefix
                        sequenceId = `SEQ_NO_${numberMatch[1].padStart(4, '0')}`;
                    } else {
                        // No number found, try to extract any number from the header
                        const anyNumberMatch = headerText.match(/(\d+)/);
                        if (anyNumberMatch) {
                            sequenceId = `SEQ_NO_${anyNumberMatch[1].padStart(4, '0')}`;
                        } else {
                            // Fallback to sequential numbering if no number found
                            sequenceId = `SEQ_NO_${(i + 1).toString().padStart(4, '0')}`;
                        }
                    }
                    const formattedSeq = `>${sequenceId}\n${currentSeq}\n`;
                    
                    // IMPROVED nucleotide detection
                    const cleanSeq = currentSeq.replace(/\s/g, '').toUpperCase();
                    
                    // Check for protein-specific amino acids first
                    const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
                    
                    // Check if sequence contains only valid nucleotide characters
                    const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
                    
                    // Count nucleotide bases
                    const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
                    const nucleotideRatio = nucleotideBases / cleanSeq.length;
                    
                    // Decision logic:
                    // 1. If contains protein-only amino acids (E,F,H,I,J,K,L,M,P,Q,R,S,V,W,Y,Z) -> Protein
                    // 2. If contains only A,T,G,C,U,N and length > 10 -> Nucleotide  
                    // 3. If >90% of bases are A,T,G,C,U -> Nucleotide
                    // 4. Otherwise -> Protein
                    
                    let isDNA = false;
                    
                    if (proteinOnlyAA) {
                        isDNA = false;
                    } else if (onlyNucleotides && cleanSeq.length > 10) {
                        isDNA = true;
                    } else if (nucleotideRatio > 0.9) {
                        isDNA = true;
                    } else {
                        isDNA = false;
                    }
                    
                    if (isDNA) {
                        dna += formattedSeq;
                        dnaCount++;
                    } else {
                        prt += formattedSeq;
                        prtCount++;
                    }
                }
                currentSeq = '';
                currentHeader = line; // Store the current header
            } else if (line) {
                // Accumulate sequence lines
                currentSeq += line;
            }
        }
        
        // Process the last sequence
        if (currentSeq && currentHeader) {
            // Extract number from original header and format as SEQ_NO_XXXX
            const headerText = currentHeader.substring(1); // Remove '>'
            const numberMatch = headerText.match(/-(\d+)/); // Look for pattern like -0032
            let sequenceId;
            if (numberMatch) {
                // Found a number after dash, use it with SEQ_NO_ prefix
                sequenceId = `SEQ_NO_${numberMatch[1].padStart(4, '0')}`;
            } else {
                // No number found, try to extract any number from the header
                const anyNumberMatch = headerText.match(/(\d+)/);
                if (anyNumberMatch) {
                    sequenceId = `SEQ_NO_${anyNumberMatch[1].padStart(4, '0')}`;
                } else {
                    // Fallback to sequential numbering if no number found
                    sequenceId = `SEQ_NO_0001`;
                }
            }
            const formattedSeq = `>${sequenceId}\n${currentSeq}\n`;
            
            // IMPROVED nucleotide detection (same logic as above)
            const cleanSeq = currentSeq.replace(/\s/g, '').toUpperCase();
            
            // Check for protein-specific amino acids first
            const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
            
            // Check if sequence contains only valid nucleotide characters
            const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
            
            // Count nucleotide bases
            const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
            const nucleotideRatio = nucleotideBases / cleanSeq.length;
            
            // Decision logic:
            // 1. If contains protein-only amino acids (E,F,H,I,J,K,L,M,P,Q,R,S,V,W,Y,Z) -> Protein
            // 2. If contains only A,T,G,C,U,N and length > 10 -> Nucleotide  
            // 3. If >90% of bases are A,T,G,C,U -> Nucleotide
            // 4. Otherwise -> Protein
            
            let isDNA = false;
            
            if (proteinOnlyAA) {
                isDNA = false;
            } else if (onlyNucleotides && cleanSeq.length > 10) {
                isDNA = true;
            } else if (nucleotideRatio > 0.9) {
                isDNA = true;
            } else {
                isDNA = false;
            }
            
            if (isDNA) {
                dna += formattedSeq;
                dnaCount++;
            } else {
                prt += formattedSeq;
                prtCount++;
            }
        }
        
        return [prt, dna, prtCount, dnaCount];
    }
};
async function getAuthInfoSt26(workflowId, history) {

    try {
        let apiurl = url.authInfoSt26;
        if (workflowId) {
            // Comes from the route URL '/antibody/parent_id={parentId}'
            //let db = 'db=wf:' + workflowId + '.resdb&parentId=' + workflowId;
            //apiurl = apiurl.replace('db=', db);
        }
        showLoader();
        return await get(apiurl, history)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
    }

}
 
export const convertingThreeToOne = async (data, history, t) => {
    const a = {
        Ala: 'A', Arg: 'R', Asn: 'N', Asp: 'D', Cys: 'C', Gln: 'Q', Glu: 'E', Gly: 'G', His: 'H',
        Ile: 'I', Leu: 'L', Lys: 'K', Met: 'M', Phe: 'F', Pro: 'P', Ser: 'S', Thr: 'T', Trp: 'W',
        Tyr: 'Y', Val: 'V', Xaa: 'X', Glx: 'Z', Asx: 'B'
    };

    if (data.st26input.startsWith(">")) {
        return 'parsererror';
    } else if (data.st26input === '') {
        return 'empty';
    }

    let new_file = "";
    let lines = data.st26input.trim().split('\n');
    let isInSequence = false;
    let sequence = '';
    let hasValidTag400 = false;

    for (let line of lines) {
        line = line.trim();

        if (line.startsWith('<')) {
            if (isInSequence && sequence.length > 0) {
                for (let i = 0; i < sequence.length; i += 50) {
                    new_file += sequence.slice(i, i + 50) + '\n';
                }
                sequence = '';
                isInSequence = false;
            }
            new_file += line + '\n';
            if (line.startsWith('<400>')) {
                isInSequence = true;
                hasValidTag400 = true;
            } else {
                isInSequence = false;
            }
        } else if (/^\d+$/.test(line)) {
            continue;
        } else if (isInSequence || /^[A-Za-z\s\*]+$/g.test(line)) {
            let cleanedLine = line.replace(/\d+/g, '').trim();

            if (/^[A-Z\*]+$/.test(cleanedLine)) {
                // Input looks like 1-letter code → invalid
                return 'parsererror';
            }

            let chunks = cleanedLine.match(/[A-Z][a-z]*|[*]{1,3}/g);
            if (chunks) {
                for (let chunk of chunks) {
                    if (chunk === '***' || chunk.startsWith('*')) {
                        sequence += '*';
                    } else if (a.hasOwnProperty(chunk)) {
                        sequence += a[chunk];
                    } else {
                        sequence += chunk;
                    }
                }
                isInSequence = true;
            }
        } else {
            new_file += line + '\n';
        }
    }

    if (isInSequence && sequence.length > 0) {
        for (let i = 0; i < sequence.length; i += 50) {
            new_file += sequence.slice(i, i + 50) + '\n';
        }
    }

    // If no <400> tags found, try parsing the entire input as raw three-letter codes
    // (e.g. "Met Ala Ala Asp Gly Tyr..." with optional line numbers like 1, 5, 10, 15)
    if (!hasValidTag400) {
        let rawSequence = '';
        for (let line of lines) {
            let cleanedLine = line.trim();
            if (!cleanedLine) continue;
            // Skip lines that are only numbers (position markers like "1  5  10  15")
            if (/^[\d\s]+$/.test(cleanedLine)) continue;
            // Remove embedded numbers from lines (e.g. trailing "15" in sequence lines)
            cleanedLine = cleanedLine.replace(/\d+/g, '').trim();
            if (!cleanedLine) continue;
            let chunks = cleanedLine.match(/[A-Z][a-z]{2}/g);
            if (chunks) {
                for (let chunk of chunks) {
                    if (a.hasOwnProperty(chunk)) {
                        rawSequence += a[chunk];
                    }
                }
            }
        }
        if (rawSequence.length > 0) {
            new_file = '';
            for (let i = 0; i < rawSequence.length; i += 50) {
                new_file += rawSequence.slice(i, i + 50) + '\n';
            }
            return new_file.trim();
        }
        return 'parsererror';
    }

    return new_file.trim();
}

export const convertingSingleToThree = async (data, history, t) => {
    const a = {
        A: 'Ala', R: 'Arg', N: 'Asn', D: 'Asp', C: 'Cys', Q: 'Gln', E: 'Glu', G: 'Gly', H: 'His',
        I: 'Ile', L: 'Leu', K: 'Lys', M: 'Met', F: 'Phe', P: 'Pro', S: 'Ser', T: 'Thr', W: 'Trp',
        Y: 'Tyr', V: 'Val', X: 'Xaa',
    };
 
    if (data.st26input.startsWith(">")) {
        return 'parsererror';
    } else if (data.st26input === '') {
        return 'empty';
    }
 
    let new_file = '';
    const lines = data.st26input.split('\n');
    let shouldConvert = false;
 
    for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
 
        if (line.startsWith('<400>')) {
            shouldConvert = true;
            new_file += line + '\n';
            continue;
        }
 
        if (shouldConvert && /^[A-Z\s]+$/.test(line.trim())) {
            let convertedLine = '';
            for (let j = 0; j < line.length; j++) {
                const codon = line[j];
                if (a[codon]) {
                    convertedLine += a[codon] + ' ';
                } else {
                    convertedLine += codon;
                }
            }
            new_file += convertedLine.trim() + '\n';
        } else {
            new_file += line + '\n';
        }
    }
 
    return new_file;
};

export const convertingST25ToFasta = async (data, history, t) => {
    const sequences = {
        Ala: 'A', Arg: 'R', Asn: 'N', Asp: 'D', Cys: 'C', Gln: 'Q', Glu: 'E', Gly: 'G', His: 'H',
        Ile: 'I', Leu: 'L', Lys: 'K', Met: 'M', Phe: 'F', Pro: 'P', Ser: 'S', Thr: 'T', Trp: 'W',
        Tyr: 'Y', Val: 'V', Xaa: 'X'
    };

    if (data.st26input.startsWith(">")) {
        return 'parsererror';
    } else if (data.st26input === '\n') {
        return 'empty';
    }else if(!data.st26input.includes('<400>')){
        return 'missing';
    }

    // Ensure that data.st26input is always treated as an array of lines
    let lines = [];
    if (typeof data.st26input === 'string') {
        lines = data.st26input.split(/\r?\n/);
    } else if (Array.isArray(data.st26input)) {
        lines = data.st26input;
    }

    let newFile = '';
    let currentSequenceNumber = '';
    let currentSequence = '';
    let currentDescription = '';
    let printedSequences = {};

    for (let line of lines) {
        line = line.trim();

        if (line.startsWith('<210>')) {
            if (currentSequenceNumber !== '') {
                if (!(currentSequenceNumber in printedSequences)) {
                    newFile += '>' + currentSequenceNumber + ' ' + currentDescription + '\n' + wrapSequence(currentSequence) + '\n';
                    printedSequences[currentSequenceNumber] = true;
                }
                currentSequence = ''; // Reset the current sequence after printing
            }
            currentSequenceNumber = line.substring('<210>'.length).trim();
        } else if (line.startsWith('<213>') || line.startsWith('<211>') || line.startsWith('<212>')) {
            continue;
        } 
        // else if (line.startsWith('<120>')) {
        //     currentDescription += line.substring('<120>'.length).trim() + ' '; // Concatenate description until next tag
        //     let nextLineIndex = lines.indexOf(line) + 1;
        //     let nextLine = nextLineIndex < lines.length ? lines[nextLineIndex] : null;
        //     while (nextLine && !nextLine.startsWith('<')) {
        //         currentDescription += nextLine.trim() + ' ';
        //         nextLineIndex++;
        //         nextLine = nextLineIndex < lines.length ? lines[nextLineIndex] : null;
        //     }
        // } Description for the sequence
        else if (line.startsWith('<')) {
            continue;
        } else {
            let chunks = line.split(/\s+/);
            for (let chunk of chunks) {
                if (sequences.hasOwnProperty(chunk)) {
                    currentSequence += sequences[chunk];
                }
            }
        }
    }

    if (currentSequenceNumber !== '') {
        if (!(currentSequenceNumber in printedSequences)) {
            newFile += '>' + currentSequenceNumber + ' ' + currentDescription + '\n' + wrapSequence(currentSequence) + '\n';
            printedSequences[currentSequenceNumber] = true;
        }
    }

    // console.log(newFile);

    return newFile;
};

function wrapSequence(sequence) {
    let wrappedSequence = '';
    while (sequence.length > 0) {
        wrappedSequence += sequence.substring(0, 80) + '\n';
        sequence = sequence.substring(80);
    }
    return wrappedSequence;
}

export const convertingST25ForParsedXml = (postData) => {
    try {
        const st26input = postData.st26input;
        if (!st26input || st26input.trim() === '') {
            return 'empty';
        }

        // Basic validation for ST25 format
        if (!st26input.includes('<400>')) {
            return 'parsererror';
        }

        const lines = st26input.split('\n').map(line => line.trim()).filter(line => line.length > 0);
        
        let prt = '';
        let dna = '';
        let prtCount = 0;
        let dnaCount = 0;
        let currentSequence = {};
        let hasValidSequence = false;
        
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            
            if (line.startsWith('<210>')) {
                // Start of new sequence block
                currentSequence = {};
            } else if (line.startsWith('<212>')) {
                // Molecule type
                const molType = line.replace('<212>', '').trim();
                currentSequence.molType = molType;
            } else if (line.startsWith('<400>')) {
                // Sequence identifier
                const seqId = line.replace('<400>', '').trim();
                currentSequence.seqId = seqId;
                
                // Get the sequence data from the next line(s)
                let j = i + 1;
                let sequenceData = '';
                while (j < lines.length && !lines[j].startsWith('<')) {
                    sequenceData += lines[j] + ' ';
                    j++;
                }
                
                // Clean up the sequence data
                sequenceData = sequenceData.trim().replace(/\s+/g, ' ');
                
                if (!sequenceData) {
                    continue; // Skip if no sequence data found
                }
                
                hasValidSequence = true;
                
                // Process based on molecule type
                if (currentSequence.molType === 'PRT') {
                    // Convert three-letter amino acid codes to single letter
                    const threeToOne = {
                        'Ala': 'A', 'Arg': 'R', 'Asn': 'N', 'Asp': 'D',
                        'Cys': 'C', 'Glu': 'E', 'Gln': 'Q', 'Gly': 'G',
                        'His': 'H', 'Ile': 'I', 'Leu': 'L', 'Lys': 'K',
                        'Met': 'M', 'Phe': 'F', 'Pro': 'P', 'Ser': 'S',
                        'Thr': 'T', 'Trp': 'W', 'Tyr': 'Y', 'Val': 'V',
                        'Xaa': 'X'
                    };
                    
                    const singleLetterSeq = sequenceData.split(/\s+/)
                        .filter(code => isNaN(code) && code.trim() !== '') // Filter out numbers and empty strings
                        .map(code => threeToOne[code])
                        .filter(letter => letter !== undefined) // Only keep valid amino acid codes
                        .join('');
                    
                    prt += `>SEQ_NO_${currentSequence.seqId}\n${singleLetterSeq}\n`;
                    prtCount++;
                } else {
                    // Nucleotide sequence (DNA, RNA, etc.)
                    const cleanedSeq = sequenceData.replace(/\s+/g, '').toLowerCase();
                    dna += `>SEQ_NO_${currentSequence.seqId}\n${cleanedSeq}\n`;
                    dnaCount++;
                }
                
                i = j - 1; // Skip to after the sequence data
            }
        }
        
        if (!hasValidSequence) {
            return 'empty';
        }
        
        return [prt, dna, prtCount, dnaCount];
    } catch (error) {
        console.error('Error in convertingST25ForParsedXml:', error);
        return 'parsererror';
    }
};

export const convertDNAFastaToProteins = (data, frames) => {
    const iupacCodes = {
      A: ['A'], C: ['C'], G: ['G'], T: ['T'],
      R: ['A', 'G'], Y: ['C', 'T'], S: ['G', 'C'], W: ['A', 'T'],
      K: ['G', 'T'], M: ['A', 'C'], B: ['C', 'G', 'T'], D: ['A', 'G', 'T'],
      H: ['A', 'C', 'T'], V: ['A', 'C', 'G'], N: ['A', 'C', 'G', 'T']
    };
  
    const codonTable = {
      TTT: 'F', TTC: 'F', TTA: 'L', TTG: 'L', CTT: 'L', CTC: 'L', CTA: 'L', CTG: 'L',
      ATT: 'I', ATC: 'I', ATA: 'I', ATG: 'M', GTT: 'V', GTC: 'V', GTA: 'V', GTG: 'V',
      TCT: 'S', TCC: 'S', TCA: 'S', TCG: 'S', CCT: 'P', CCC: 'P', CCA: 'P', CCG: 'P',
      ACT: 'T', ACC: 'T', ACA: 'T', ACG: 'T', GCT: 'A', GCC: 'A', GCA: 'A', GCG: 'A',
      TAT: 'Y', TAC: 'Y', TAA: '*', TAG: '*', CAT: 'H', CAC: 'H', CAA: 'Q', CAG: 'Q',
      AAT: 'N', AAC: 'N', AAA: 'K', AAG: 'K', GAT: 'D', GAC: 'D', GAA: 'E', GAG: 'E',
      TGT: 'C', TGC: 'C', TGA: '*', TGG: 'W', CGT: 'R', CGC: 'R', CGA: 'R', CGG: 'R',
      AGT: 'S', AGC: 'S', AGA: 'R', AGG: 'R', GGT: 'G', GGC: 'G', GGA: 'G', GGG: 'G'
    };
  
    const expandCodon = (codon) => {
      const bases = codon.split('').map(base => iupacCodes[base] || []);
      const results = [];
  
      const backtrack = (pos = 0, current = '') => {
        if (pos === 3) {
          results.push(current);
          return;
        }
        for (const base of bases[pos]) {
          backtrack(pos + 1, current + base);
        }
      };
  
      if (bases.every(b => b.length > 0)) backtrack();
      return results;
    };
  
    const getCodonAA = (codon) => {
      if (!/^[ACGTURYSWKMBDHVN]{3}$/i.test(codon)) return 'X';
      const possibleCodons = expandCodon(codon);
      const aminoAcids = new Set();
      for (const c of possibleCodons) {
        const aa = codonTable[c];
        if (aa) aminoAcids.add(aa);
      }
      return aminoAcids.size === 1 ? [...aminoAcids][0] : 'X';
    };
  
    const translateFrame = (seq, offset) => {
      let protein = '';
      for (let i = offset; i + 2 < seq.length; i += 3) {
        const codon = seq.slice(i, i + 3);
        protein += getCodonAA(codon);
      }
      return protein;
    };
  
    const reverseComplement = seq => {
      const comp = { A: 'T', T: 'A', C: 'G', G: 'C' };
      return seq.split('').reverse().map(b => comp[b] || 'N').join('');
    };
  
    const validFrames = ['+1', '+2', '+3', '-1', '-2', '-3'];
  
    let selectedFrames = [];
    if (typeof frames === 'string') {
      selectedFrames = frames.toLowerCase() === 'all' ? validFrames : [frames];
    } else if (Array.isArray(frames)) {
      selectedFrames = frames;
    }
  
    const rawInput = typeof data === 'string' ? data : data?.st26input || '';
    if (!rawInput.trim()) {
      console.log('error');
      return 'EmptyInputError';
    }
  
    const entries = rawInput.trim().split(/^>(.+)$/gm).filter(Boolean);
    const translations = [];
  
    for (let i = 0; i < entries.length; i += 2) {
      const header = entries[i].trim().replace(/\s+/g, '-');
      const rawSeq = entries[i + 1].replace(/\s+/g, '').toUpperCase();
  
      const iupacValid = /^[ACGTUNWSMKRYBDHVQ.-]+$/i;
      if (!iupacValid.test(rawSeq)) return 'parsererror';
      if (rawSeq.length < 3) return 'TooShortError';
  
      const sequence = rawSeq;
  
      selectedFrames.forEach(frame => {
        const cleanedFrame = frame.trim();
        if (!validFrames.includes(cleanedFrame)) {
          console.warn(`Invalid frame ignored: ${cleanedFrame}`);
          return;
        }
  
        const isReverse = cleanedFrame.startsWith('-');
        const offset = parseInt(cleanedFrame[1], 10) - 1;
        const seqToTranslate = isReverse ? reverseComplement(sequence) : sequence;
        const protein = translateFrame(seqToTranslate, offset);
      
        // Format title
        const direction = isReverse ? 'Reverse' : 'Forward';
        const formattedHeader = `>${header}_${direction}_Frame_${cleanedFrame}`;
  
        translations.push({
          title: formattedHeader,
          sequence: protein
        });
      });
    }
  
    return { translations };
  };


const st26service = {
    convertXml,
    getAuthInfoSt26,
    convertText,
    convertFastaForParsedXml,
    convertingThreeToOne,
    convertingSingleToThree,
    convertingST25ToFasta,
    convertingST25ForParsedXml,
    convertDNAFastaToProteins
};

export default st26service;
